export interface AffiliatePathFlags {
  isNerdwallet: boolean;
  isUsaToday: boolean;
  isForbesAdvisor: boolean;
  isMoneyTalksNews: boolean;
  isMyBankTracker: boolean;
  isCNN: boolean;
  isAffiliate: boolean;
}

export const getAffiliatePathFlags = (pathname: string): AffiliatePathFlags => {
  const isNerdwallet = pathname.includes('/forms/nerdwallet');
  const isUsaToday = pathname.includes('/forms/usa-today');
  const isForbesAdvisor = pathname.includes('/forms/forbes-advisor');
  const isMoneyTalksNews = pathname.includes('/forms/moneytalksnews');
  const isMyBankTracker = pathname.includes('/forms/mybanktracker');
  const isCNN = pathname.includes('/forms/cnn');

  return {
    isNerdwallet,
    isUsaToday,
    isForbesAdvisor,
    isMoneyTalksNews,
    isMyBankTracker,
    isCNN,
    isAffiliate:
      isNerdwallet ||
      isUsaToday ||
      isForbesAdvisor ||
      isMoneyTalksNews ||
      isMyBankTracker ||
      isCNN,
  };
};

export interface AffiliateLogo {
  src: string;
  testId: string;
}

/* moneyTalksNews counts as an affiliate but has no logo of its own, so it
   falls through to the plain Zoe logo below — matches the historical
   behaviour rather than an oversight. */
export const getAffiliateLogo = (
  flags: AffiliatePathFlags,
): AffiliateLogo | undefined => {
  if (flags.isNerdwallet) {
    return {
      src: '/static/svg/partners/nerdwallet.svg',
      testId: 'nerdwallet-logo',
    };
  }

  if (flags.isUsaToday) {
    return {
      src: '/static/img/partners/usa-today.png',
      testId: 'usa-today-logo',
    };
  }

  if (flags.isForbesAdvisor) {
    return {
      src: '/static/img/partners/forbes-advisor.png',
      testId: 'forbes-logo',
    };
  }

  if (flags.isMyBankTracker) {
    return {
      src: '/static/img/partners/mybanktracker.svg',
      testId: 'mybanktracker-logo',
    };
  }

  if (flags.isCNN) {
    return {
      src: '/static/img/partners/cnn-shape-black.png',
      testId: 'cnn-logo',
    };
  }

  return undefined;
};
